import { WaitlistAlert } from '@weave/schema-gen-ts/dist/schemas/schedule/v3/notifications.pb';
import { useCommonActionSubscriptions } from './actions/use-common-actions-subscriptions';
import { useNotificationActionSubscription } from './actions/use-notification-action-subscription';
import { useNotification } from './use-notification';

export const useScheduleWaitlistNotification = (onView: (payload: WaitlistAlert) => void) => {
  const { create, remove } = useNotification<'schedule-waitlist'>();

  useCommonActionSubscriptions('schedule-waitlist');
  useNotificationActionSubscription('schedule-waitlist', 'view', ({ notification }) => {
    onView(notification.payload);
    remove(notification.id);
  });

  return {
    create,
    remove,
  };
};
